/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Approval decision DTO
 */
export enum ApprovalDecisionDto {

    Approved = 'Approved',

    Rejected = 'Rejected',

    NeedsReview = 'NeedsReview'
}
